module.exports = __webpack_public_path__ + "img/icon-logo-navbar.fb782553.svg";